
import React, { useState, forwardRef, useRef, useEffect } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails, MenuItem,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import { BootstrapDialog, BootstrapDialogTitle } from '../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../reusableComponent/StyledTable';
import styles from '../../styles.module.css';
import tax_img from '../../images/tax-icon.png'
import { ERPinput, ERPinputNo } from '../reusableComponent/ErpTextField';
import { addPaymentInvoiceDeduction, editDeletePaymentInvoiceDeduction, getPaymentInvoiceDeduction } from '../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { dateConversionOnEntryPage } from '../reusableComponent/dateConversionOnEntryPage';



const PaymentInvoiceDeduction = (props) => {
    const [deductionDetail, setDeductionDetail] = useState()
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);

    const [data, setData] = useState({
        invoice_id: props.details.invoiceId,
        invoice_no: props.details.invoiceNo,
        invoiceDate: props.details.invoiceDate,
        CNS_Type: props.details.CNS_Type,
        CNS_Id: props.details.CNS_id,
        ded_title: '',
        ded_ref_no: '',
        ded_amount: '',
        TDS_amount: '',
        TCS_amount: '',
        gst: '',
    });

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }
    const rows = useSelector(state => state.paymentInvoiceDeduction.paymentInvoiceDeduction)
    const fetchData = () => {
        dispatch(getPaymentInvoiceDeduction({ companyId: userInfo.companyId, invoice_id: props.details.invoiceId, CNS_Type: props.details.CNS_Type }))
    };

    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {
        if (rows.length === 0) {
            setDeductionDetail('add');
        } else {
            setDeductionDetail('detail');
        }
    }, [rows]);

    const [successMessage, setSuccessMessage] = useState(null);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.paymentInvoiceDeduction.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                // setIsDelete(false);
                // setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);
    const onSubmit = (event) => {
        const DeductionData = {
            companyId: userInfo.companyId,
            ...data,
            createdBy: userInfo.userId,
            createdAt: dateConversionOnEntryPage(new Date()),
            modifiedBy: userInfo.userId,
            modifiedAt: dateConversionOnEntryPage(new Date()),
            changedUpdatedValue: 'edit',
        }
       
        dispatch(addPaymentInvoiceDeduction(DeductionData));
       
    }

    return (
        <>

            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>
                <Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1} sx={{}}>
                            {/* <Grid item xs={6}
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    backgroundImage: `url(${tax_img})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderRight: '1px solid #c0c0c0',
                                }}
                            >
                            </Grid> */}
                            {deductionDetail == 'detail' ?
                                <Grid item xs={12} >
                                    <Grid container spacing={2} sx={{ mt: 0 }}>
                                        <Grid item md={3.4}>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>{location.pathname == '/sales' ? "Customer Name" : "Supplier Name"}</Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Invoice No</Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Deduction Title</Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Deduction Ref. No </Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Deduction Amount</Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>TDS Amount</Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>TCS Amount</Typography>
                                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>GST %</Typography>
                                        </Grid>
                                        <Grid item md={0.6}>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                        </Grid>
                                        <Grid item md={8}>
                                            {rows && rows.map((row, index) => (
                                                <>
                                                    <Typography className={`${styles.erp_lable}`}> {props.details.CNS_Name} </Typography>
                                                    <Typography className={`${styles.erp_lable}`}>{row.invoice_no} </Typography>
                                                    <Typography className={`${styles.erp_lable}`}> {row.ded_title}</Typography>
                                                    <Typography className={`${styles.erp_lable}`}> {row.ded_ref_no}</Typography>
                                                    <Typography className={`${styles.erp_lable}`}> {row.ded_amount} </Typography>
                                                    <Typography className={`${styles.erp_lable}`}> {row.TDS_amount} </Typography>
                                                    <Typography className={`${styles.erp_lable}`}> {row.TCS_amount} </Typography>
                                                    <Typography className={`${styles.erp_lable}`}> {row.gst} </Typography>
                                                </>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                :
                                <Grid item xs={12} >
                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Invoice No</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="text"
                                                name="invoice_no"
                                                value={(data.invoice_no)}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </Grid>
                                     
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Deduction Title</Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="text"
                                                onChange={handleChange}
                                                name="ded_title"
                                                value={(data.ded_title)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Deduction Ref. No</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="text"
                                                onChange={handleChange}
                                                name="ded_ref_no"
                                                value={(data.ded_ref_no)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Deduction Amount</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <ERPinputNo
                                                size='small'
                                                fullWidth
                                                type="number"
                                                onChange={handleChange}
                                                name="ded_amount"
                                                value={(data.ded_amount)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>TDS Amount</Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinputNo
                                                size='small'
                                                fullWidth
                                                type="number"
                                                onChange={handleChange}
                                                name="TDS_amount"
                                                value={(data.TDS_amount)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>TCS Amount </Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinputNo
                                                fullWidth
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                type="number"
                                                name="TCS_amount"
                                                value={(data.TCS_amount)}
                                                size='small'
                                                onChange={(e) => handleChange(e)}
                                            />

                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>GST % </Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinputNo
                                                size='small'
                                                fullWidth
                                                type="number"
                                                onChange={handleChange}
                                                name="gst"
                                                value={(data.gst)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ marginTop: '12px', float: 'right' }}>
                                        <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                            {'Save'}
                                        </Button>
                                    </Box>
                                </Grid>
                            }
                        </Grid>


                    </form>
                </Box>
            </Paper>
        </>
    )
}
export default PaymentInvoiceDeduction;